import IMedia       from '../../../Player/Interfaces/IMedia';
import StoreName    from '../../Shared/Constants/StoreName';
import IPlayerState from '../../Shared/Interfaces/IPlayerState';

import IMediaStore         from './Interfaces/IMediaStore';
import Media               from './Media';
import resolveMediaActions from './resolveMediaActions';

const createMediaStore = (
    state: IPlayerState,
    initialValue: IMedia = {}
): IMediaStore =>
    state.createStore({
        name: StoreName.MEDIA,
        model: Media,
        actions: resolveMediaActions
    }, initialValue);

export default createMediaStore;
